<template>
  <div style="width:100%;">
    <div class="diaContainer yauto">
      <!-- 其他用章审批新增表单 -->
      <el-form
        ref="addChapterForm1"
        :rules="rules"
        :model="addChapterForm"
        v-if="showForm==='showFormZhuanAdd'"
        label-position="right"
        label-width="160px"
      >
        <div class="diaForm_box">
          <div class="diaFormTitle">项目信息</div>
          <div style="box-sizing:border-box;padding:0 10%">
            <!-- 项目名称 -->
            <el-form-item label="项目名称" v-if="$store.state.process.finance.isFromProjectBar">
              <span
                style="color:#666;font-size:16px;line-height:40px"
              >{{$store.state.process.finance.projectName}}</span>
            </el-form-item>
            <el-form-item label="项目名称" v-else>
              <!-- 在本地搜索 -->
              <!-- <el-select
                style="width:100%"
                v-model="addChapterForm.project_id"
                filterable
                @change="handleProjectSelectChange1"
                :disabled="draftDisable"
                multiple
                placeholder="请选择"
              >
                <el-option
                  v-for="(item,num) in projectList"
                  style="max-width: 40vw;"
                  :key="item.project_id"
                  :label="item.project_show"
                  :value="item.project_id"
                ></el-option>
              </el-select> -->

<!-- 远程搜索 -->
<el-select
                style="width:100%"
                v-model="addChapterForm.project_id"
                filterable
                remote
                multiple
                @change="handleProjectSelectChange1"
                :disabled="draftDisable"
                :filter-method="projectSearch"
                placeholder="请选择"
              >
                <el-option
                  v-for="(item,num) in projectList"
                  style="max-width: 40vw;"
                  :key="item.project_id"
                  :label="item.project_show"
                  :value="item.project_id"
                ></el-option>
              </el-select>

            </el-form-item>
            <!-- 项目编号 -->
            <!-- <el-form-item label="项目编号" style="margin-bottom:0">
                <span>{{selectProjectNum}}</span>
            </el-form-item>-->
          </div>
        </div>
        <div class="diaForm_box">
          <div class="diaFormTitle">用章信息</div>
          <div style="box-sizing:border-box;padding:0 10%">
            <!-- 申请人 -->
            <el-form-item label="申请人" style="margin-bottom:0px;" v-if="addChapterForm.member">
              <span
                v-if="addChapterForm.member"
                style="color:#666;font-size:16px"
              >{{addChapterForm.member.nickname}}</span>
            </el-form-item>

            <!-- 预设审批人 -->
            <el-form-item
              label="预设审批人"
              prop="preset_member"
              style="margin-bottom:30px;"
              v-if="$store.state.process.admin.list3.length>0"
            >
              <el-select
                style="width:100%"
                v-model="addChapterForm.preset_member"
                filterable
                :disabled="draftDisable"
                clearable
                placeholder="请选择"
              >
                <el-option
                  v-for="item in $store.state.process.admin.list3"
                  style="max-width: 40vw;"
                  :key="item.member_id"
                  :label="item.nickname"
                  :value="item.member_id"
                ></el-option>
              </el-select>
            </el-form-item>

            <!-- 报告/文件名称 -->
            <el-form-item label="报告/文件名称">
              <el-input
                :disabled="draftDisable"
                placeholder="请输入报告/文件名称"
                v-model="addChapterForm.business_name"
              ></el-input>
            </el-form-item>
            <!-- 印章类别 -->
            <el-form-item label="印章类别" style="margin-bottom:0px;">
              <el-radio-group v-model="addChapterForm.seal_type" :disabled="draftDisable">
                <el-radio label="1">公章</el-radio>
                <el-radio label="2">法人章</el-radio>
                <el-radio label="3">合同专用章</el-radio>
                <el-radio label="4">报告专用章</el-radio>
              </el-radio-group>
            </el-form-item>
            <!-- 申请原因 -->
            <el-form-item label="申请原因" style="margin-bottom:0px;">
              <el-radio-group
                v-model="addChapterForm.reason_id"
                @change="isOtherClear"
                :disabled="draftDisable"
              >
                <el-radio label="1">报告</el-radio>
                <el-radio label="2">发票</el-radio>
                <el-radio label="3">招投标</el-radio>
                <el-radio label="4" @click="">报价</el-radio>
                <el-radio label="-1">其他</el-radio>
              </el-radio-group>
            </el-form-item>

<!-- 报价单详情 -->
             <el-dialog
   :visible.sync="dialogVisible_4"
    title="报价单详情"
append-to-body
 @close="BaojiaDetailClose"
  >

  <div>
   <el-form
      
        :rules="rules"
        :model="addChapterFormBaojia"
      
        label-position="right"
        label-width="160px"
      >
       
        <div class="diaForm_box diaEditFormBox">
          <div class="diaFormTitle">项目信息</div>
          <div style="box-sizing:border-box;padding:0 10%">
            <!-- 项目名称 -->
            <el-form-item label="项目名称" v-if="$store.state.process.finance.isFromProjectBar">
              <span
                style="color:#666;font-size:16px;line-height:40px"
              >{{$store.state.process.finance.projectName}}</span>
            </el-form-item>
            <el-form-item label="项目名称" class="containerNoDis" v-else>
              <el-select
                style="width:100%"
                v-model="addChapterFormBaojia.project_id"
                filterable
                v-if="addChapterFormBaojia.is_edit=='1'"
                @change="handleProjectSelectChange1"
                :disabled="draftDisable"
                multiple
                placeholder="请选择"
              >
                <el-option
                  v-for="(item,num) in projectList"
                  style="max-width: 40vw;"
                  :key="item.project_id"
                  :label="item.project_show"
                  :value="item.project_id"
                ></el-option>
              </el-select>
              <span
                v-else
                class="projectContainerInbox"
                v-for="(items,index) in addChapterFormBaojia.project_list"
                style="color:#666;font-size:16px;"
              >
                <span
                  class="projectHoverBlue"
                  @click.stop="goProjectDetailsOpenNew(items)"
                  v-if="index<addChapterFormBaojia.project_list.length-1"
                >{{items.project_name+','}}</span>
                <span
                  class="projectHoverBlue"
                  @click.stop="goProjectDetailsOpenNew(items)"
                  v-else
                >{{items.project_name}}</span>
              </span>
            </el-form-item>
         
          </div>
        </div>
        <div class="diaForm_box diaEditFormBox">
          <div class="diaFormTitle">用章信息</div>
          <div style="box-sizing:border-box;padding:0 10%">
            <!-- 申请人 -->
            <el-form-item label="申请人" style="margin-bottom:0px;" v-if="addChapterForm.member">
              <span
                v-if="addChapterFormBaojia.member"
                style="color:#666;font-size:16px"
              >{{addChapterFormBaojia.member.nickname}}</span>
            </el-form-item>
            <!-- 预设审批人 -->
            <el-form-item
              label="预设审批人"
              prop="preset_member"
              style="margin-bottom:30px;"
              v-if="addChapterFormBaojia.is_edit=='1' && $store.state.process.admin.list3.length>0"
            >
              <el-select
                style="width:100%"
                v-model="addChapterFormBaojia.preset_member"
                filterable
                :disabled="draftDisable"
                clearable
                placeholder="请选择"
              >
                <el-option
                  v-for="item in $store.state.process.admin.list3"
                  style="max-width: 40vw;"
                  :key="item.member_id"
                  :label="item.nickname"
                  :value="item.member_id"
                ></el-option>
              </el-select>
            </el-form-item>
            <!-- 报告/文件名称 -->
            <el-form-item label="报告/文件名称">
              <el-input
                v-if="addChapterFormBaojia.is_edit=='1'"
                placeholder="请输入报告/文件名称"
                v-model="addChapterFormBaojia.business_name"
              ></el-input>
              <span v-else style="color:#666;font-size:16px">{{addChapterFormBaojia.business_name}}</span>
            </el-form-item>
            <!-- 印章类别 -->
            <el-form-item label="印章类别" style="margin-bottom:0px;">
              <el-radio-group v-model="addChapterFormBaojia.seal_type" v-if="addChapterFormBaojia.is_edit=='1'">
                <el-radio label="1">公章</el-radio>
                <el-radio label="2">法人章</el-radio>
                <el-radio label="3">合同专用章</el-radio>
                <el-radio label="4">报告专用章</el-radio>
              </el-radio-group>
              <span v-else style="color:#666;font-size:16px">
                <span v-if="addChapterFormBaojia.seal_type=='1'">公章</span>
                <span v-if="addChapterFormBaojia.seal_type=='2'">法人章</span>
                <span v-if="addChapterFormBaojia.seal_type=='3'">合同专用章</span>
                <span v-if="addChapterFormBaojia.seal_type=='4'">报告专用章</span>
              </span>
            </el-form-item>

             <!-- 申请原因 -->
            <el-form-item label="申请原因" style="margin-bottom:0px;">
              <el-radio-group v-model="addChapterFormBaojia.reason_id" v-if="addChapterFormBaojia.is_edit=='1'">
                <el-radio label="1">报告</el-radio>
                <el-radio label="2">发票</el-radio>
                <el-radio label="3">招投标</el-radio>
                <el-radio label="4">报价</el-radio>
                <el-radio label="5">其他</el-radio>
              </el-radio-group>
              <span v-else style="color:#666;font-size:16px">
                <span v-if="addChapterFormBaojia.reason_id=='1'">报告</span>
                <span v-if="addChapterFormBaojia.reason_id=='2'">发票</span>
                <span v-if="addChapterFormBaojia.reason_id=='3'">招投标</span>
                <span v-if="addChapterFormBaojia.reason_id=='4'">报价</span>
                <span v-if="addChapterFormBaojia.reason_id=='-1'">其他</span>
              </span>
            </el-form-item>
       
        
            <!-- 份数 -->
            <el-form-item label="份数">
              <el-input
                v-if="addChapterFormBaojia.is_edit=='1'"
                placeholder="请输入份数"
                type="number"
                v-model="addChapterFormBaojia.num"
              ></el-input>
              <span v-else style="color:#666;font-size:16px">{{addChapterFormBaojia.num}}</span>
            </el-form-item>
            <!-- 经办人 -->
            <el-form-item label="经办人">
              <el-input
                v-if="addChapterFormBaojia.is_edit=='1'"
                placeholder="请输入经办人"
                v-model="addChapterFormBaojia.manager"
              ></el-input>
              <span v-else style="color:#666;font-size:16px">{{addChapterFormBaojia.manager}}</span>
            </el-form-item>
            <div
              v-if="addChapterFormBaojia.is_edit=='1'"
              style="font-size:12px;margin-left:160px;color: rgb(245, 95, 95);margin-bottom:20px;margin-top:20px"
            >*合作项目报告盖章需要把电子档上传到附件</div>

            <!-- 附件 -->
            <el-form-item label="附件">
              <upload-file
                style="width:100%"
                :isSubmit="addChapterFormBaojia.is_edit=='1'"
                :imgList="addChapterFormBaojia.annex"
                :detailsImgList="addChapterFormBaojia.annex"
                @my-upload-change="upLoadChange"
              ></upload-file>
            </el-form-item>
            <!-- 备注 -->
            <el-form-item label="备注" style="margin-bottom:20px">
              <el-input
                v-if="addChapterFormBaojia.is_edit=='1'"
                placeholder="请输入备注信息"
                type="textarea"
                v-model="addChapterFormBaojia.remark"
              ></el-input>
              <el-input
                type="textarea"
                class="onlyShowText"
                disabled
                autosize
                v-else
                v-model="addChapterFormBaojia.remark"
              ></el-input>
            </el-form-item>
          </div>
        </div>

        <div class="diaForm_box diaEditFormBox">
          <div class="diaFormTitle">审批信息</div>
          <div style="box-sizing:border-box;padding:0 10%">
            <!-- 已通过 -->
            <el-timeline>
              <el-timeline-item
                v-for="(activity, index) in addChapterFormBaojia.approval_log"
                :color="activity.approval_status==0?'':'#128bf1'"
                :key="index"
              >
                <div style="margin-bottom:5px">
                  <span>提交人:</span>
                  <span>{{activity.memberInfo.nickname}}</span>
                  <span style="margin:0 10px;color:rgb(18, 139, 241)">提交</span>
                  <span>{{activity.add_time}}</span>
                </div>
                <div>
                  <span
                    v-if="activity.approval_status=='1'"
                    style="margin-right:10px"
                  >{{activity.executorInfo.nickname}}</span>
                  <span v-if="activity.approval_status=='1'" style="color:rgb(18, 139, 241)">通过</span>
                  <span
                    v-if="activity.approval_status=='-1'"
                    style="margin-right:10px"
                  >{{activity.executorInfo.nickname}}</span>
                  <span v-if="activity.approval_status=='-1'" style="color:rgb(255, 51, 51)">驳回</span>
                  <span
                    v-if="activity.approval_status=='-2'"
                    style="margin-right:10px"
                  >{{activity.executorInfo.nickname}}</span>
                  <span v-if="activity.approval_status=='-2'" style="color:rgb(255, 51, 51)">审批撤回</span>
                  <span
                    v-if="activity.approval_status=='0'"
                    v-for="item in activity.tomemberInfo"
                    style="margin-right:10px"
                  >{{item.nickname+' '}}</span>
                  <span v-if="activity.approval_status=='0'" style="color:rgb(255, 51, 51)">待审批</span>
                  <span
                    style="margin-left:10px"
                    v-if="activity.update_time"
                  >{{activity.update_time}}</span>
                </div>
                <div class="remark" style="margin-top:5px" v-if="activity.remark">
                  <span style="margin-right:5px">备注:</span>
                  <span style="color:rgb(255, 51, 51)">{{activity.remark}}</span>
                </div>
              </el-timeline-item>
            </el-timeline>
          </div>
        </div>
      </el-form>

     </div>
   
 </el-dialog>
<!-- 报价单详情結束 -->

              <div v-if="addChapterForm.reason_id==4"
              style="font-size:13px;margin-left:160px;margin-bottom:10px"     
            >
            <span style="color: rgb(245, 95, 95);"> *请先搜索确认该项目是否已有报价单，避免重复</span>
           
           <!-- <span style="margin-left: 10px;color: #128bf1;"  @click="clickBaojia()">选中后，点击此处可查看报价单详情</span> -->
           </div>
  <!-- <el-form-item label="已有报价单">
              <el-input
                :disabled="draftDisable"
                placeholder="报告/文件名称"
                v-model="addChapterForm.manager"
                clearable
              ></el-input>
            </el-form-item> -->

            <!-- 已有报价单 -->
             <el-form-item v-if="addChapterForm.reason_id==4" label="报价单检索" >


              <!-- <el-input            
              @input="Boxinput"
            @blur="baojia_box_show=false"
              @focus="baojia_box_show=true"
  placeholder="报告/文件名称"
  v-model="baojia_name"
  clearable>
</el-input>
<div class="baojia-list-box" v-if="baojia_box_show">
<div 
  class="baojia-list" 
  v-for="(item, num) in baojia_project_list" 
  @click.stop="handleBaojiaClick(item)"
>
  {{ item.business_name }}
</div>
</div> -->
              <el-select
                style="width:100%"
               v-model="baojia_search"
                :filterable="true"
                :remote="true"
                multiple
                :remote-method="getBaojiaProjectList"
               clearable 
                placeholder="报告/文件名称"
                @change="handleProjectSelectChange2"
              >
                <el-option
                  v-for="(item,num) in baojia_project_list"
                  style="max-width: 40vw;"
                  :key="item.id"
                  :label="item.business_name"
                  :value="item.id"
             
                ></el-option>
              </el-select>
            </el-form-item>
           <!-- 已有报价单 -->

            
          

            <!-- 其他原因 -->
            <el-form-item
              label="其他原因"
              style="margin-bottom:0px;"
              v-if="addChapterForm.reason_id=='-1'"
            >
              <el-input
                :disabled="draftDisable"
                placeholder="请输入其他原因"
                type="textarea"
                v-model="addChapterForm.reason_else"
              ></el-input>
            </el-form-item>
            <!-- 份数 -->
            <el-form-item label="份数">
              <el-input
                :disabled="draftDisable"
                type="number"
                placeholder="请输入份数"
                v-model="addChapterForm.num"
              ></el-input>
            </el-form-item>
            <!-- 经办人 -->
            <el-form-item label="经办人">
              <el-input
                :disabled="draftDisable"
                placeholder="请输入经办人"
                v-model="addChapterForm.manager"
              ></el-input>
            </el-form-item>
            <div
              style="font-size:12px;margin-left:160px;color: rgb(245, 95, 95);margin-bottom:20px"
            >*合作项目报告盖章需要把电子档上传到附件</div>
            <!-- 附件 -->
            <el-form-item label="附件">
              <upload-file
                style="width:100%"
                :isSubmit="!draftDisable"
                :imgList="this.imgList"
                :detailsImgList="detailsImgList"
                @my-upload-change="upLoadChange"
              ></upload-file>
            </el-form-item>
            <!-- 备注 -->
            <el-form-item label="备注" style="margin-bottom:20px">
              <el-input
                :disabled="draftDisable"
                placeholder="请输入备注信息"
                type="textarea"
                v-model="addChapterForm.remark"
              ></el-input>
            </el-form-item>
          </div>
        </div>
      </el-form>
      <!-- 其他用章审批审批表单 -->
      <el-form
        ref="addChapterForm2"
        :rules="rules"
        :model="addChapterForm"
        v-if="showForm==='showFormZhuanHandle' && $store.state.process.admin.dialogVisible"
        label-position="right"
        label-width="160px"
      >
        <div class="diaForm_box diaEditFormBox">
          <div class="ShowFormBtn">
            <el-button
              v-if="addChapterForm.withdraw_status=='1'"
              @click="handleFinnaceWithDraw('chapter',addChapterForm.id)"
              :disabled="disableLimit"
              class="withdrap"
              style="background-color:rgb(255, 26, 26);"
            >撤回</el-button>
            <el-button
              v-if="addChapterForm.is_just=='1'"
              @click="handleFinnaceApproveWithDraw('chapter',addChapterForm.id)"
              :disabled="disableLimit"
              class="withdrap"
              style="background-color:rgb(255, 26, 26);"
            >审批撤回</el-button>
            <el-button
              @click="approveVisible=true"
              v-if="addChapterForm.approval_status=='1'"
              class="creat"
              style="background-color:#40A0F2;"
            >去审批</el-button>
          </div>
        </div>
        <div class="diaForm_box diaEditFormBox">
          <div class="diaFormTitle">项目信息</div>
          <div style="box-sizing:border-box;padding:0 10%">
            <!-- 项目名称 -->
            <el-form-item label="项目名称" v-if="$store.state.process.finance.isFromProjectBar">
              <span
                style="color:#666;font-size:16px;line-height:40px"
              >{{$store.state.process.finance.projectName}}</span>
            </el-form-item>
            <el-form-item label="项目名称" class="containerNoDis" v-else>
              <el-select
                style="width:100%"
                v-model="addChapterForm.project_id"
                filterable
                v-if="addChapterForm.is_edit=='1'"
                @change="handleProjectSelectChange1"
                :disabled="draftDisable"
                multiple
                placeholder="请选择"
              >
                <el-option
                  v-for="(item,num) in projectList"
                  style="max-width: 40vw;"
                  :key="item.project_id"
                  :label="item.project_show"
                  :value="item.project_id"
                ></el-option>
              </el-select>
              <span
                v-else
                class="projectContainerInbox"
                v-for="(items,index) in addChapterForm.project_list"
                style="color:#666;font-size:16px;"
              >
                <span
                  class="projectHoverBlue"
                  @click.stop="goProjectDetailsOpenNew(items)"
                  v-if="index<addChapterForm.project_list.length-1"
                >{{items.project_name+','}}</span>
                <span
                  class="projectHoverBlue"
                  @click.stop="goProjectDetailsOpenNew(items)"
                  v-else
                >{{items.project_name}}</span>
              </span>
            </el-form-item>
            <!-- 项目编号 -->
            <!-- <el-form-item label="项目编号" style="margin-bottom:10px">
                <span style="color:#666;font-size:16px">{{selectProjectNum}}</span>
            </el-form-item>-->
            <!-- 项目类型 -->
            <!-- <el-form-item label="项目类型" style="margin-bottom:10px">
                <span style="color:#666;font-size:16px">双重预防</span>
            </el-form-item>-->
          </div>
        </div>
        <div class="diaForm_box diaEditFormBox">
          <div class="diaFormTitle">用章信息</div>
          <div style="box-sizing:border-box;padding:0 10%">
            <!-- 申请人 -->
            <el-form-item label="申请人" style="margin-bottom:0px;" v-if="addChapterForm.member">
              <span
                v-if="addChapterForm.member"
                style="color:#666;font-size:16px"
              >{{addChapterForm.member.nickname}}</span>
            </el-form-item>
            <!-- 预设审批人 -->
            <el-form-item
              label="预设审批人"
              prop="preset_member"
              style="margin-bottom:30px;"
              v-if="addChapterForm.is_edit=='1' && $store.state.process.admin.list3.length>0"
            >
              <el-select
                style="width:100%"
                v-model="addChapterForm.preset_member"
                filterable
                :disabled="draftDisable"
                clearable
                placeholder="请选择"
              >
                <el-option
                  v-for="item in $store.state.process.admin.list3"
                  style="max-width: 40vw;"
                  :key="item.member_id"
                  :label="item.nickname"
                  :value="item.member_id"
                ></el-option>
              </el-select>
            </el-form-item>
            <!-- 报告/文件名称 -->
            <el-form-item label="报告/文件名称">
              <el-input
                v-if="addChapterForm.is_edit=='1'"
                placeholder="请输入报告/文件名称"
                v-model="addChapterForm.business_name"
              ></el-input>
              <span v-else style="color:#666;font-size:16px">{{addChapterForm.business_name}}</span>
            </el-form-item>
            <!-- 印章类别 -->
            <el-form-item label="印章类别" style="margin-bottom:0px;">
              <el-radio-group v-model="addChapterForm.seal_type" v-if="addChapterForm.is_edit=='1'">
                <el-radio label="1">公章</el-radio>
                <el-radio label="2">法人章</el-radio>
                <el-radio label="3">合同专用章</el-radio>
                <el-radio label="4">报告专用章</el-radio>
              </el-radio-group>
              <span v-else style="color:#666;font-size:16px">
                <span v-if="addChapterForm.seal_type=='1'">公章</span>
                <span v-if="addChapterForm.seal_type=='2'">法人章</span>
                <span v-if="addChapterForm.seal_type=='3'">合同专用章</span>
                <span v-if="addChapterForm.seal_type=='4'">报告专用章</span>
              </span>
            </el-form-item>
            <!-- 申请原因 -->
            <el-form-item label="申请原因" style="margin-bottom:0px;">
              <el-radio-group v-model="addChapterForm.reason_id" v-if="addChapterForm.is_edit=='1'">
                <el-radio label="1">报告</el-radio>
                <el-radio label="2">发票</el-radio>
                <el-radio label="3">招投标</el-radio>
                <el-radio label="4">报价</el-radio>
                <el-radio label="5">其他</el-radio>
              </el-radio-group>
              <span v-else style="color:#666;font-size:16px">
                <span v-if="addChapterForm.reason_id=='1'">报告</span>
                <span v-if="addChapterForm.reason_id=='2'">发票</span>
                <span v-if="addChapterForm.reason_id=='3'">招投标</span>
                <span v-if="addChapterForm.reason_id=='4'">报价</span>
                <span v-if="addChapterForm.reason_id=='-1'">其他</span>
              </span>
            </el-form-item>
            <!-- 其他原因 -->
            <el-form-item
              label="其他原因"
              style="margin-bottom:0px;"
              v-if="addChapterForm.reason_id=='-1'"
            >
              <el-input
                v-if="addChapterForm.is_edit=='1'"
                placeholder="请输入其他原因"
                type="textarea"
                v-model="addChapterForm.reason_else"
              ></el-input>
              <el-input
                type="textarea"
                class="onlyShowText"
                disabled
                autosize
                v-else
                v-model="addChapterForm.reason_else"
              ></el-input>
            </el-form-item>
            <!-- 份数 -->
            <el-form-item label="份数">
              <el-input
                v-if="addChapterForm.is_edit=='1'"
                placeholder="请输入份数"
                type="number"
                v-model="addChapterForm.num"
              ></el-input>
              <span v-else style="color:#666;font-size:16px">{{addChapterForm.num}}</span>
            </el-form-item>
            <!-- 经办人 -->
            <el-form-item label="经办人">
              <el-input
                v-if="addChapterForm.is_edit=='1'"
                placeholder="请输入经办人"
                v-model="addChapterForm.manager"
              ></el-input>
              <span v-else style="color:#666;font-size:16px">{{addChapterForm.manager}}</span>
            </el-form-item>
            <div
              v-if="addChapterForm.is_edit=='1'"
              style="font-size:12px;margin-left:160px;color: rgb(245, 95, 95);margin-bottom:20px;margin-top:20px"
            >*合作项目报告盖章需要把电子档上传到附件</div>

            <!-- 附件 -->
            <el-form-item label="附件">
              <upload-file
                style="width:100%"
                :isSubmit="addChapterForm.is_edit=='1'"
                :imgList="this.imgList"
                :detailsImgList="detailsImgList"
                @my-upload-change="upLoadChange"
              ></upload-file>
            </el-form-item>
            <!-- 备注 -->
            <el-form-item label="备注" style="margin-bottom:20px">
              <el-input
                v-if="addChapterForm.is_edit=='1'"
                placeholder="请输入备注信息"
                type="textarea"
                v-model="addChapterForm.remark"
              ></el-input>
              <el-input
                type="textarea"
                class="onlyShowText"
                disabled
                autosize
                v-else
                v-model="addChapterForm.remark"
              ></el-input>
            </el-form-item>
          </div>
        </div>

        <div class="diaForm_box diaEditFormBox">
          <div class="diaFormTitle">审批信息</div>
          <div style="box-sizing:border-box;padding:0 10%">
            <!-- 已通过 -->
            <el-timeline>
              <el-timeline-item
                v-for="(activity, index) in addChapterForm.approval_log"
                :color="activity.approval_status==0?'':'#128bf1'"
                :key="index"
              >
                <div style="margin-bottom:5px">
                  <span>提交人:</span>
                  <span>{{activity.memberInfo.nickname}}</span>
                  <span style="margin:0 10px;color:rgb(18, 139, 241)">提交</span>
                  <span>{{activity.add_time}}</span>
                </div>
                <div>
                  <span
                    v-if="activity.approval_status=='1'"
                    style="margin-right:10px"
                  >{{activity.executorInfo.nickname}}</span>
                  <span v-if="activity.approval_status=='1'" style="color:rgb(18, 139, 241)">通过</span>
                  <span
                    v-if="activity.approval_status=='-1'"
                    style="margin-right:10px"
                  >{{activity.executorInfo.nickname}}</span>
                  <span v-if="activity.approval_status=='-1'" style="color:rgb(255, 51, 51)">驳回</span>
                  <span
                    v-if="activity.approval_status=='-2'"
                    style="margin-right:10px"
                  >{{activity.executorInfo.nickname}}</span>
                  <span v-if="activity.approval_status=='-2'" style="color:rgb(255, 51, 51)">审批撤回</span>
                  <span
                    v-if="activity.approval_status=='0'"
                    v-for="item in activity.tomemberInfo"
                    style="margin-right:10px"
                  >{{item.nickname+' '}}</span>
                  <span v-if="activity.approval_status=='0'" style="color:rgb(255, 51, 51)">待审批</span>
                  <span
                    style="margin-left:10px"
                    v-if="activity.update_time"
                  >{{activity.update_time}}</span>
                </div>
                <div class="remark" style="margin-top:5px" v-if="activity.remark">
                  <span style="margin-right:5px">备注:</span>
                  <span style="color:rgb(255, 51, 51)">{{activity.remark}}</span>
                </div>
              </el-timeline-item>
            </el-timeline>
          </div>
        </div>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <!-- 其他用章申请新增按钮 -->
      <el-button
        style="background-color: #ccc;"
        v-if="showForm==='showFormZhuanAdd' && addChapterForm.is_draft!='1'"
        @click="handleAddExpertSubmit('1')"
        :disabled="disableLimit"
      >保存草稿</el-button>
      <el-button
        type="primary"
        v-if="showForm==='showFormZhuanAdd' && addChapterForm.is_draft!='1'"
        @click="handleAddExpertSubmit('0')"
        :disabled="disableLimit"
      >提 交</el-button>
      <!-- 其他用章申请编辑按钮 -->
      <el-button
        style="background-color: #ccc;"
        v-if="showForm==='showFormZhuanAdd' && addChapterForm.is_draft=='1' && !draftDisable"
        @click="handleEditExpertSubmit('1')"
        :disabled="disableLimit"
      >保存草稿</el-button>
      <el-button
        type="primary"
        v-if="showForm==='showFormZhuanAdd' && addChapterForm.is_draft=='1' && !draftDisable"
        @click="handleEditExpertSubmit('0')"
        :disabled="disableLimit"
      >提 交</el-button>
      <!-- 其他用章申请重新提交 -->
      <el-button
        style="background-color: #ccc;"
        v-if="showForm==='showFormZhuanHandle' && addChapterForm.is_edit=='1'"
        @click="getDialogVisible(false)"
      >取 消</el-button>
      <el-button
        type="primary"
        v-if="showForm==='showFormZhuanHandle' && addChapterForm.is_edit=='1'"
        @click="handleEditExpertSubmit('0')"
        :disabled="disableLimit"
      >提 交</el-button>
    </div>
    <sign-dialog
      @wirtDoen="handleWriteDone"
      :visible.sync="receiverSignFlag"
      @change="handleReceiverSign"
    ></sign-dialog>
    <!-- 弹窗--审批 -->
    <el-dialog
      :visible.sync="approveVisible"
      width="60%"
      class="addClientDia"
      :before-close="approveVisibleClose"
      append-to-body
      @close="approveVisibleClosed"
      :modal-append-to-body="false"
      v-dialogDrag
    >
      <div slot="title" class="header-title">
        <span class="title-age">审批</span>
      </div>
      <div>
        <el-form ref="form" label-position="right" label-width="160px">
          <div class="diaForm_box diaEditFormBox">
            <div
              v-if="addChapterForm.approval_status=='1'"
              style="font-size:12px;padding-right:30px;text-align:right;color: rgb(245, 95, 95);margin-bottom:20px;margin-top:0px"
            >*您可以选择驳回后发起人提交的节点</div>
            <!-- 自动审批大通按钮 -->
            <el-form-item label="自动审批" v-if="addChapterForm.approval_status=='1'">
              <div style="height:40px;display:flex;align-items:center;">
                <el-switch
                  active-value="1"
                  inactive-value="0"
                  v-model="is_chase"
                  active-color="#128bf1"
                  inactive-color="#ccc"
                ></el-switch>
              </div>
            </el-form-item>
            <el-form-item label="驳回节点" v-if="addChapterForm.approval_status=='1'">
              <el-select style="width:95%" v-model="k_code" placeholder="请选择">
                <el-option
                  style="max-width: 40vw;"
                  v-for="(item,index) in addChapterForm.stage_selectArry"
                  :key="item.id"
                  :value="item.id"
                  :label="item.label"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="审批备注" v-if="addChapterForm.approval_status=='1'">
              <el-input
                style="width:95%"
                placeholder="审批备注"
                type="textarea"
                v-model="approvalRemark"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="签名"
              v-if="addChapterForm.approval_status=='1'"
              style="margin-bottom:20px"
            >
              <img
                v-if="!sign_pic"
                @click="handleReceiverFlag"
                style="width:66px;height:66px;"
                src="../../../assets/image/zaixianqianm@2x.png"
                alt
              />
              <img
                v-if="sign_pic"
                @click="handleReceiverFlag(sign_pic)"
                style="width:66px;height:66px;"
                :src="sign_pic"
                alt
              />
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button
          @click="handleFinnaceApproval('-1','chapter',addChapterForm.id)"
          :disabled="disableLimit"
          style="background:#f4a029;"
          v-if="addChapterForm.approval_status=='1'"
          class="search"
        >驳回</el-button>
        <el-button
          @click="handleFinnaceApproval('1','chapter',addChapterForm.id)"
          :disabled="disableLimit"
          v-if="addChapterForm.approval_status=='1'"
          class="creat"
          style="background-color:#40A0F2;"
        >通过</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
import UploadFile from '../../../components/UploadFile'
import SignDialog from '../../../components/SignDialog'


import 'viewerjs/dist/viewer.css'
import { api as viewerApi } from 'v-viewer'
import { watch } from 'less'

export default {
  data() {
    return {
      // 审批窗口
      approveVisible: false,
      sign_pic: '',
      receiverSignFlag: false,
      // 禁用按钮防抖
      disableLimit: false,

      imgList: [],
      detailsImgList: [],

      k_code: '',
      token: '',
      member_id: '',
      company_id: '',
      cache_department_id: '',
      tiemID1: null,
      timeDou: 100,
      // 新增其他用章审批
      addChapterForm: {
        remark: '',
        annex: '',
        project_id: [],

        seal_type: '1',
        num: 1,
        business_name: '',
        reason_id: '1',
        reason_else: '',
        manager: '',
        group_id:''
      },
      approvalRemark: '',
      // 自动审批大通
      is_chase: '0',
      rules: {
        preset_member: [
          { required: true, message: '请选择预设审批人', trigger: 'change' },
        ],
      },

      // 选择的申请原因,4为报价
      
      dialogVisible_4:false,

      // 报价单列表
      baojia_project_list:[],
      baojia_search:'',
     addChapterFormBaojia:{},

     whether_to_search:true,

     // 报价单列表是否展示
     baojia_box_show:false,
     baojia_name:''
    }
  },
  props: [],
  components: {
    UploadFile,
    SignDialog,
  },
  watch: {
    '$store.state.process.admin.formData'(newval, olval) {
      this.addChapterForm = newval
    },
    '$store.state.process.admin.dialogVisible'(newval, olval) {
      if (newval == false) {
        this.is_chase = '0'
      }
    },
    'addChapterForm.annex': {
      handler: function (val, oldVal) {
        this.imgList = val
        this.detailsImgList = val
      },
    },
    // 默认驳回节点是当前节点
    'addChapterForm.stage_selectArry': {
      handler: function (val, oldVal) {
        if (val && val.length > 0) {
          this.k_code = val[val.length - 1].id
        } else {
          this.k_code = ''
        }
      },
    },

   
  },
  methods: {
Boxinput(e){
 console.log('shuru',e)
},
  handleBaojiaClick(item) {
    // 处理点击逻辑
    console.log('点击的项目:', item)
    // 这里可以访问 Vue 实例的 data、methods 等
  },
// 报价单详情关闭时清空选择的项目
BaojiaDetailClose(){
 this.addChapterFormBaojia = {}
},

// 获取报价单详情
async getBaojiaProjectDetail(id){

 let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      param.append('company_id', this.company_id)
     
           param.append('finance_id', id)
 
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Service/chapter_detail',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.addChapterFormBaojia = res.datas.info
     this.addChapterFormBaojia.is_edit = '0'
      console.log('获取报价单详情', this.addChapterFormBaojia)
},

 // 点击打开报价单详情
clickBaojia(){
 
 if(!this.baojia_search[0]){
  // this.$message.error('请选择一个报价单项目')
return 
 }
this.getBaojiaProjectDetail(this.baojia_search[0])

     this.dialogVisible_4 = true
},
   
    // 选择报价单项目
    async handleProjectSelectChange2(val) {
   
      if (val && val.length > 1) {
        // this.$message.error('关联项目只能选择1个')
        this.baojia_search= [val[0]]
      }
        console.log('选择报价单项目',val)
      // 强制刷新组件
      // this.$forceUpdate()
    },
// 获取报价单列表
async getBaojiaProjectList(search){
 if(search==''){
  return
 }


   let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      param.append('company_id', this.company_id)
      param.append('search', search||'')
           param.append('reason_id', '4')

   
    
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Service/chapter',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.baojia_project_list = res.datas.listInfo
      console.log('报价单项目列表', this.baojia_project_list)
},



 // 按搜索条件查找，不在本地进行查找
 async projectSearch(val){
   if(!val)return
   console.log(val)
    let param = new FormData()
      param.append('member_id', localStorage.getItem('btlh_process_member_id') || '')
      param.append('token', localStorage.getItem('btlh_process_token') || '')
      
      param.append('cache_department_id', localStorage.getItem('bthl_process_cache_department_id_store') || '')
      param.append('company_id', localStorage.getItem('bthl_process_LoginCompanyId') || '')
   
      param.append('search', val)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Project/simple_project',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      console.log(res.datas.listInfo)
      this.$store.commit(
        'process/admin/assignmentProject',
        res.datas.listInfo
      )
      if (res.datas.listInfo.length > this.moreNum) {
        this.$store.commit(
          'process/admin/setprojectListSub',
          res.datas.listInfo.slice(0, this.moreNum)
        )
      } else {
        this.$store.commit(
          'process/admin/setprojectListSub',
          res.datas.listInfo
        )
      }
      console.log('获取项目列表', this.$store.state.process.finance.projectList)
     
   },


    ...mapMutations('process/admin', ['getDialogVisible', 'userFilter']),
    projectFilter(query = '') {
      let arr = this.projectList.filter((item) => {
        return (
          item.project_id.includes(query) || item.project_show.includes(query)
        )
      })
      console.log('arr', arr)
      if (arr.length == 0) {
        this.$forceUpdate()
      }
      if (arr.length > this.moreNum) {
        this.$store.commit(
          'process/admin/setprojectListSub',
          arr.slice(0, this.moreNum)
        )
      } else {
        this.$store.commit('process/admin/setprojectListSub', arr)
      }
    },
    isOtherClear(e) {
     

      if (this.addChapterForm.reason_id != '-1') {
        this.addChapterForm.reason_else = ''
      }
      console.log('申请原因',this.addChapterForm.reason_id)
    },
    handleReceiverFlag(url) {
      this.receiverSignFlag = true
    },
    handleWriteDone(data) {
      this.sign_pic = data
    },
    handleReceiverSign() {},

    jiesuanChangeClick() {
      if (this.addArrivalForm.is_settle == '1') {
        this.addArrivalForm.is_settlement = '1'
      }
    },
    // 点击新窗口打开项目页面
    goProjectDetailsOpenNew(items) {
      console.log('items', items)
      // this.$router.resolve({
      //   path: '/project/details/task',
      //   query: {
      //     project_id: items.project_id,
      //     project_name: items.project_name,
      //     isEdit: '1',
      //   },
      // })
      let routeUrl = this.$router.resolve({
        path: '/project/details/task',
        query: {
          project_id: items.project_id,
          project_name: items.project_name,
          isEdit: '1',
          formFinance: '1',
          project_status: '',
        },
      })
      window.open(routeUrl.href)
    },
    upLoadChange(data) {
      this.imgList = data
    },
    // *审批撤回
    async handleFinnaceApproveWithDraw(stage_code, finance_id) {
      this.disableLimit = true
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)

      param.append('finance_id', finance_id)
      param.append('stage_code', stage_code)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Management/finance_approve_withdraw',
        data: param,
      })
      if (res.code != 200) {
        this.disableLimit = false
        return this.$message.error(res.datas.msg)
      }
      this.disableLimit = false
      this.$message.success(res.datas.msg)

      this.getList()
      if (this.$route.path == '/myFlow') {
        this.$store.commit('process/myFlow/get_finnace_coming_list_mutation')
      }
      this.getDialogVisible(false)
    },
    // *撤回
    async handleFinnaceWithDraw(stage_code, finance_id) {
      this.disableLimit = true
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)

      param.append('finance_id', finance_id)
      param.append('stage_code', stage_code)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Finance/withdraw',
        data: param,
      })
      if (res.code != 200) {
        this.disableLimit = false
        return this.$message.error(res.datas.msg)
      }
      this.disableLimit = false
      this.$message.success(res.datas.msg)

      this.getList()
      if (this.$route.path == '/myFlow') {
        this.$store.commit('process/myFlow/get_finnace_coming_list_mutation')
      }
      this.getDialogVisible(false)
    },
    // *财务审批(详情页点击通过或驳回)
    async handleFinnaceApproval(val, stage_code, finance_id) {
      this.disableLimit = true
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)

      param.append('finance_id', finance_id)
      param.append('stage_code', stage_code)

      param.append('approval_status', val)
      param.append('remark', this.approvalRemark)
      param.append('k_code', this.k_code)
      param.append('is_chase', this.is_chase)

      param.append('sign_pic', this.sign_pic)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Management/finance_approval',
        data: param,
      })
      if (res.code != 200) {
        this.disableLimit = false
        return this.$message.error(res.datas.msg)
      }
      this.$message.success(res.datas.msg)
      this.disableLimit = false
      // 清空驳回节点
      this.k_code = ''
      this.sign_pic = ''
      this.approvalRemark = ''
      this.getList()
      if (this.$route.path == '/myFlow') {
        this.$store.commit('process/myFlow/get_finnace_coming_list_mutation')
      }
      this.getDialogVisible(false)
      this.approveVisible = false
    },

    // *编辑其他用章审批提交
    async handleEditExpertSubmit(val) {
      if (this.$store.state.process.admin.list3.length > 0) {
        // 判断是不是草稿
        if (this.addChapterForm.is_draft == '1') {
          this.$refs.addChapterForm1.validate(async (valid) => {})
        } else {
          this.$refs.addChapterForm2.validate(async (valid) => {})
        }
      }

      this.disableLimit = true
      clearTimeout(this.tiemID)
      this.tiemID = setTimeout(async () => {
        let param = new FormData()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)
        param.append('is_draft', val)
        param.append('finance_id', this.addChapterForm.id)

        param.append('annex', JSON.stringify(this.imgList))
        param.append('remark', this.addChapterForm.remark)

        // 单选
        // param.append('project_id', this.addChapterForm.project_id.join(','))
        if (this.$store.state.process.finance.isFromProjectBar) {
          param.append(
            'project_id',
            this.$store.state.process.finance.projectId
          )
        } else {
          param.append('project_id', this.addChapterForm.project_id.join(','))
        }

        param.append('preset_member', this.addChapterForm.preset_member)

        param.append('seal_type', this.addChapterForm.seal_type)
        param.append('num', this.addChapterForm.num)
        param.append('business_name', this.addChapterForm.business_name)
        param.append('reason_id', this.addChapterForm.reason_id)
        param.append('reason_else', this.addChapterForm.reason_else)
        param.append('manager', this.addChapterForm.manager)

        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Service/chapter_edit',
          data: param,
        })
        if (res.code != 200) {
          this.disableLimit = false
          return this.$message.error(res.datas.msg)
        }
        this.$message.success(res.datas.msg)
        this.disableLimit = false
        this.getList()
        if (this.$route.path == '/myFlow') {
          this.$store.commit('process/myFlow/get_finnace_coming_list_mutation')
        }

        this.getDialogVisible(false)
      }, this.timeDou)
    },
    // *其他用章审批新增点击提交
    async handleAddExpertSubmit(val) {
      if (this.$store.state.process.admin.list3.length > 0) {
        this.$refs.addChapterForm1.validate(async (valid) => {
          //   如果校验失败
          // if (valid == false) return this.$message.error('角色信息不合规')
          // 如果校验成功
        })
      }

      this.disableLimit = true
      clearTimeout(this.tiemID)
      this.tiemID = setTimeout(async () => {
        let param = new FormData()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)
        param.append('is_draft', val)

        param.append('annex', JSON.stringify(this.imgList))
        param.append('remark', this.addChapterForm.remark)

        // 多选
        // param.append('project_id', this.addChapterForm.project_id.join(','))

        if (this.$store.state.process.finance.isFromProjectBar) {
          param.append(
            'project_id',
            this.$store.state.process.finance.projectId
          )
        } else {
          param.append('project_id', this.addChapterForm.project_id.join(','))
        }

        param.append('preset_member', this.addChapterForm.preset_member)

        param.append('seal_type', this.addChapterForm.seal_type)
        param.append('num', this.addChapterForm.num)
        param.append('business_name', this.addChapterForm.business_name)
        param.append('reason_id', this.addChapterForm.reason_id)
        param.append('reason_else', this.addChapterForm.reason_else)
        param.append('manager', this.addChapterForm.manager)

        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Service/chapter_add',
          data: param,
        })
        if (res.code != 200) {
          this.disableLimit = false
          return this.$message.error(res.datas.msg)
        }
        this.$message.success(res.datas.msg)
        this.disableLimit = false
        this.getList()
        if (this.$route.path == '/myFlow') {
          this.$store.commit('process/myFlow/get_finnace_coming_list_mutation')
        }
        this.getDialogVisible(false)
      }, this.timeDou)
    },

    getList() {
      if (this.$store.state.process.finance.isFromProjectBar) {
        this.$store.commit(
          'process/admin/getChapterList',
          this.$store.state.process.finance.projectId
        )
        this.$store.commit(
          'process/finance/getFinanceSildeBarNum',
          this.$store.state.process.finance.projectId
        )
      } else {
        this.$store.commit('process/admin/getChapterList')
      }
    },
    // 选择项目名称1
    async handleProjectSelectChange1(val) {
      if (val && val.length > 1) {
        this.$message.error('关联项目只能选择1个')
        this.addChapterForm.project_id = [val[0]]
      }
      // 强制刷新组件
      this.$forceUpdate()
    },
    approveVisibleClose() {
      this.approveVisible = false
    },
    approveVisibleClosed() {
      this.is_chase = '0'
      this.k_code = ''
      this.approvalRemark = ''
      this.sign_pic = ''
    },
  },
  activated() {},

  async created() {
    if (this.$refs.addChapterForm2) {
      this.$refs.addChapterForm2.clearValidate()
    }
    this.addChapterForm = JSON.parse(
      JSON.stringify(this.$store.state.process.admin.formData)
    )
    if (this.addChapterForm.annex) {
      this.imgList = this.addChapterForm.annex
      this.detailsImgList = this.addChapterForm.annex
    }
    console.log('adsadimglist', this.imgList)
    this.disableLimit = false
    this.token = localStorage.getItem('btlh_process_token') || ''
    this.member_id = localStorage.getItem('btlh_process_member_id') || ''
    this.company_id = localStorage.getItem('bthl_process_LoginCompanyId') || ''
    this.cache_department_id =
      localStorage.getItem('bthl_process_cache_department_id_store') || ''

      this.getBaojiaProjectList();
     
  },
  mounted() {
   this.Boxinput()
  },

  computed: {
    ...mapState('process/admin', [
      'showForm',
      'draftDisable',
      'formData',
      'moreNum',
      'projectList',
      'projectListSub',
    ]),
  },
}
</script>
<style lang="less" scoped>
@import url(../../../views/topBar/finance.scss);
.search-keyword-more {
  width: 100%;
  text-align: center;
  font-size: 14px;
  color: #999;
}
.baojia-list-box{
width: 100%;background-color: #fff;height: 300px;box-shadow: 1px 5px 9px 0px rgba(3, 70, 126, 0.14);z-index: 2000;position: absolute;top: 50px;
 overflow: scroll; 
  
    transition: max-height 0.5s ease-out; /* 添加动画效果 */
}

.baojia-list{
font-size: 14px;
padding-left: 6px;
padding-right: 6px;
}
.baojia-list:hover{
background-color: #f5f7fa;
}

</style>